module.exports = __webpack_public_path__ + "img/hp-h5.bde7b47e.svg";